
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Play } from "lucide-react";

export const VideoPresentation = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-300">
            <AspectRatio ratio={16 / 9}>
              <div className="w-full h-full bg-gray-100 flex flex-col items-center justify-center">
                {/* YouTube-like Play Button */}
                <div className="rounded-full bg-red-600 p-5 mb-3 shadow-lg">
                  <Play className="h-12 w-12 text-white" fill="white" strokeWidth={0} />
                </div>
                <p className="text-gray-500 text-lg">Vidéo à venir prochainement</p>
              </div>
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>
  );
};
